export default "__VITE_ASSET__C0_5xc52__"